module.exports = __webpack_public_path__ + "media/images/manos-7bccb0275addda46c809821c0706b56e.jpg";